<template>
  <div class="modal fade" id="modal_mfa_setup" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #dbdcde !important">
        <div class="modal-body" style="min-height: auto !important">
          <div class="text-center" v-if="is_loading">
            <img src="/images/loading.gif" />
          </div>
          <template v-else>
            <UpdateMFAComponent :mfa_info="mfa_info" @close="close" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UpdateMFAComponent from '~/components/user/mfa/UpdateMFAComponent.vue';

  export default {
    name: 'MFAModalPopupComponent',
    components: {
      UpdateMFAComponent,
    },
    props: {
      mfa_info: {
        type: Object,
        default() {
          return {
            email: '',
            phone: '',
          };
        },
      },
      user: {
        type: Object,
        default() {
          return null;
        },
      },
    },
    data: function () {
      return {
        is_loading: true,
      };
    },
    mounted() {
      this.setDefaults();
      this.is_loading = false;
    },
    methods: {
      setDefaults() {
        if (!this.mfa_info.email && !this.mfa_info.phone) {
          this.mfa_info.email = this.user.email;
          this.mfa_info.phone = this.user.phone;
        }
      },
      close() {
        this.setDefaults();
        $('#modal_mfa_setup').modal('hide');
      },
    },
  };
</script>
